import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { useSelector } from 'react-redux';

import InputTypeField from './InputTypeField';
import InputUriField from './InputUriField';
import InputEndpointUrlField from './InputEndpointUrlField';
import InputPathField from './InputPathField';
import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function InputDataSection({
  values,
  errors,
  setValues,
  setErrors,
  setChanged,
  edit,
}) {
  const project_datastores = useSelector((state) => state.projectDatastores);

  const handleInputTypeChange = (value) => {
    if (!value) {
      setValues({
        ...values,
        input_type: value,
        input_uri: '',
        input_options: undefined,
      });
      setErrors({
        ...errors,
        input_uri_error: false,
      });
    } else {
      const uriTest = Object.values(THIRD_PARTY_TYPES).find(
        (type) => type.value === value
      )?.uriTest;
      const valid = uriTest ? uriTest.test(values.input_uri) : true;
      setValues({
        ...values,
        input_type: value,
        input_options: undefined,
      });
      setErrors({
        ...errors,
        input_uri_error: Boolean(values.input_uri) && !valid,
      });
    }
    setChanged();
  };

  const handleInputUriChange = (value) => {
    if (values.input_type === THIRD_PARTY_TYPES.REGIONAL.value) {
      setValues({
        ...values,
        input_uri: value,
      });
      setErrors({
        ...errors,
        input_uri_error: false,
      });
    } else {
      setValues({
        ...values,
        input_uri: value,
      });
    }
    setChanged();
  };

  const handleInputEndpointUrlChange = (value) => {
    setValues({
      ...values,
      input_options: {
        ...values.input_options,
        endpoint_url: value,
      },
    });
    setChanged();
  };

  const handleInputPathChange = (value) => {
    setValues({
      ...values,
      input_options: {
        ...values.input_options,
        path: value,
      },
    });
    setChanged();
  };

  return (
    <>
      <Grid size={12}>
        <Typography variant='h6'>Input Data</Typography>
        <Divider sx={{ mt: 1, mb: 2 }} />
      </Grid>
      <Grid size={12}>
        <InputTypeField
          value={values.input_type}
          setValue={handleInputTypeChange}
          setChanged={setChanged}
          edit={edit}
        />
      </Grid>
      {values.input_type === THIRD_PARTY_TYPES.REGIONAL.value ? (
        <>
          <Grid size={12}>
            <InputUriField
              value={values.input_uri}
              inputType={values.input_type}
              error={errors.input_uri_error}
              setValue={(value) => {
                setValues({
                  ...values,
                  input_uri: value,
                });
                setChanged();
              }}
              setError={(error) => {
                setErrors({
                  ...errors,
                  input_uri_error: error,
                });
              }}
              setChanged={setChanged}
              edit={edit}
              projectDatastores={project_datastores || []}
            />
          </Grid>
          <Grid size={12}>
            <InputPathField
              value={
                values.input_options ? values.input_options.path : ''
              }
              error={errors.input_uri_error}
              setValue={handleInputPathChange}
              setError={(error) => {
                setErrors({
                  ...errors,
                  input_uri_error: error,
                });
              }}
              setChanged={setChanged}
              edit={edit}
              inputType={values.input_type}
              inputUri={values.input_uri}
            />
          </Grid>
        </>
      ) : values.input_type === THIRD_PARTY_TYPES.WASABI.value ? (
        <>
          <Grid size={12}>
            <InputUriField
              value={values.input_uri}
              inputType={values.input_type}
              error={errors.input_uri_error}
              setValue={handleInputUriChange}
              setError={(error) => {
                setErrors({
                  ...errors,
                  input_uri_error: error,
                });
              }}
              setChanged={setChanged}
              edit={edit}
            />
          </Grid>
          <Grid size={12}>
            <InputEndpointUrlField
              value={
                values.input_options
                  ? values.input_options.endpoint_url
                  : ''
              }
              error={errors.input_endpoint_error}
              setValue={handleInputEndpointUrlChange}
              setError={(error) => {
                setErrors({
                  ...errors,
                  input_endpoint_error: error,
                });
              }}
              setChanged={setChanged}
              edit={edit}
              inputType={values.input_type}
            />
          </Grid>
        </>
      ) : values.input_type ? (
        <Grid size={12}>
          <InputUriField
            value={values.input_uri}
            inputType={values.input_type}
            error={errors.input_uri_error}
            setValue={handleInputUriChange}
            setError={(error) => {
              setErrors({
                ...errors,
                input_uri_error: error,
              });
            }}
            setChanged={setChanged}
            edit={edit}
          />
        </Grid>
      ) : undefined}
    </>
  );
}

